module.exports = __webpack_public_path__ + "static/verifyImage@2x-cbc22c61f20a997aae440c9ada3c0664.png";